"use client";

import { useState } from "react";
import { KeyRound, ShieldCheck } from "lucide-react";
import { useSession } from "@/components/session-provider";
import { ErrorNotice, Field } from "@/components/ui";
import { errorMessage, mutation } from "@/lib/api";

export function ForcedPasswordChange() {
  const session = useSession();
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);

  return (
    <main className="sign-in">
      <form
        className="sign-in-form"
        onSubmit={async (event) => {
          event.preventDefault();
          const form = event.currentTarget;
          const data = new FormData(form);
          const newPassword = String(data.get("newPassword") || "");
          if (newPassword !== String(data.get("confirmPassword") || "")) {
            setError("New passwords do not match.");
            return;
          }
          setPending(true);
          setError("");
          try {
            await mutation("/account/password", {
              currentPassword: data.get("currentPassword"),
              newPassword,
              code: data.get("code"),
            }, "PUT");
            await session.refresh();
          } catch (cause) {
            setError(errorMessage(cause));
          } finally {
            setPending(false);
          }
        }}
      >
        <div className="sign-in-heading">
          <KeyRound size={22} />
          <h1>Choose a new password</h1>
        </div>
        <p className="sign-in-help">
          Your administrator issued a temporary password. Set a new password
          to continue; the temporary password will stop working immediately.
        </p>
        <ErrorNotice message={error} />
        <Field label="Temporary password">
          <input name="currentPassword" type="password" autoComplete="current-password" required />
        </Field>
        <Field label="New password">
          <input name="newPassword" type="password" autoComplete="new-password" minLength={12} maxLength={1024} required />
        </Field>
        <Field label="Confirm new password">
          <input name="confirmPassword" type="password" autoComplete="new-password" minLength={12} maxLength={1024} required />
        </Field>
        {session.user?.totpEnabled && (
          <Field label="Authenticator or recovery code">
            <input name="code" autoComplete="one-time-code" maxLength={64} required />
          </Field>
        )}
        <button className="button button-primary" disabled={pending}>
          <ShieldCheck size={16} />
          {pending ? "Saving..." : "Set password"}
        </button>
      </form>
    </main>
  );
}
